/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_LabelInputs */



/**
* | output |
* | --- |
* | "Export Preset" |
*
* @param {Video_Export_Export_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_label = /** @type {((inputs?: Video_Export_Export_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prereglage d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export-Voreinstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta preimpostazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт предустановки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रीसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição de exportação")
	return /** @type {LocalizedString} */ ("Export Preset")
});